import { render, staticRenderFns } from "./LotInfo.vue?vue&type=template&id=4fe99942&scoped=true"
import script from "./LotInfo.vue?vue&type=script&lang=js"
export * from "./LotInfo.vue?vue&type=script&lang=js"
import style0 from "./LotInfo.vue?vue&type=style&index=0&id=4fe99942&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe99942",
  null
  
)

export default component.exports